import { Box, ListItemIcon, Typography } from "@mui/material"
import React from "react"
import { formatEventTimeRange } from "../utils"
import StatusIcon from "./StatusIcon"

/**
 * Renders an event in the "more events" modal
 */
const EventItem = React.memo(({ event, onClick }) => {
  const hasLink = Boolean(event.link)

  return (
    <Box
      sx={{
        padding: "4px 0",
        borderRadius: "6px",
        backgroundColor: "white",
        display: "flex",
        alignItems: "flex-start",
        cursor: hasLink ? "pointer" : "default",
        transition: "all 0.2s ease",
        "&:hover": {
          backgroundColor: "#f5f5f9",
        },
      }}
      onClick={hasLink ? () => onClick(event) : undefined}
    >
      <ListItemIcon sx={{ minWidth: 30, display: "flex", justifyContent: "center" }}>
        <StatusIcon status={event.status} />
      </ListItemIcon>
      <Box sx={{ flexGrow: 1 }}>
        <Typography variant="subtitle2" fontWeight="500">
          {event.title}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.75rem" }}>
          {formatEventTimeRange(event.start, event.end, event.time_zone_abbr)}
        </Typography>
      </Box>
    </Box>
  )
})

EventItem.displayName = "EventItem"

export default EventItem
